import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  MdNotificationsActive,
  MdMarkEmailRead,
  MdSearch,
  MdArrowBack,
} from "react-icons/md";
import mockNotifications, {
  getUnreadCount,
} from "../../data/mockNotifications";
import NotificationItem from "../../components/notifications/NotificationItem";
import "../../styles/dashboard-notification.css";

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState(mockNotifications);
  const [query, setQuery] = useState("");
  const [tab, setTab] = useState("all");

  const unreadCount = useMemo(
    () => getUnreadCount(notifications),
    [notifications],
  );

  const filteredNotifications = useMemo(() => {
    const q = query.trim().toLowerCase();

    return notifications.filter((item) => {
      const matchesTab =
        tab === "all" ? true : tab === "unread" ? !item.read : item.read;

      const matchesQuery =
        !q ||
        item.title.toLowerCase().includes(q) ||
        item.message.toLowerCase().includes(q);

      return matchesTab && matchesQuery;
    });
  }, [notifications, query, tab]);

  const markAllAsRead = () => {
    setNotifications((prev) => prev.map((item) => ({ ...item, read: true })));
  };

  const markOneAsRead = (id) => {
    setNotifications((prev) =>
      prev.map((item) => (item.id === id ? { ...item, read: true } : item)),
    );
  };

  return (
    <section className="notifications-page">
      <div className="notifications-page__hero">
        <div className="notifications-page__hero-left">
          <Link to="/dashboard" className="notifications-page__back-btn">
            <MdArrowBack size={18} />
            Kembali
          </Link>

          <div className="notifications-page__heading">
            <div className="notifications-page__eyebrow">
              <MdNotificationsActive size={16} />
              Notifications Center
            </div>

            <h1 className="notifications-page__title">Pusat Notifikasi</h1>
            <p className="notifications-page__subtitle">
              Kelola pemberitahuan penting, pesan baru, update listing, dan
              alert akun dalam satu tampilan yang rapi dan mudah dibaca.
            </p>
          </div>
        </div>

        <div className="notifications-page__hero-right">
          <div className="notifications-page__stat-card">
            <span className="notifications-page__stat-label">Total</span>
            <strong className="notifications-page__stat-value">
              {notifications.length}
            </strong>
          </div>

          <div className="notifications-page__stat-card notifications-page__stat-card--accent">
            <span className="notifications-page__stat-label">Unread</span>
            <strong className="notifications-page__stat-value">
              {unreadCount}
            </strong>
          </div>
        </div>
      </div>

      <div className="notifications-page__toolbar">
        <div className="notifications-page__search">
          <MdSearch size={20} />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Cari notifikasi..."
          />
        </div>

        <div className="notifications-page__tabs">
          <button
            type="button"
            className={`notifications-page__tab ${tab === "all" ? "active" : ""}`}
            onClick={() => setTab("all")}
          >
            Semua
          </button>
          <button
            type="button"
            className={`notifications-page__tab ${tab === "unread" ? "active" : ""}`}
            onClick={() => setTab("unread")}
          >
            Unread
          </button>
          <button
            type="button"
            className={`notifications-page__tab ${tab === "read" ? "active" : ""}`}
            onClick={() => setTab("read")}
          >
            Read
          </button>
        </div>

        <button
          type="button"
          className="notifications-page__mark-all"
          onClick={markAllAsRead}
        >
          <MdMarkEmailRead size={18} />
          Tandai semua dibaca
        </button>
      </div>

      <div className="notifications-page__content">
        {filteredNotifications.length === 0 ? (
          <div className="notifications-page__empty">
            <div className="notifications-page__empty-icon">
              <MdNotificationsActive size={42} />
            </div>
            <h3>Tidak ada notifikasi</h3>
            <p>Coba ubah kata kunci pencarian atau filter tab.</p>
          </div>
        ) : (
          <div className="notifications-list">
            {filteredNotifications.map((item) => (
              <div key={item.id} onClick={() => markOneAsRead(item.id)}>
                <NotificationItem item={item} />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default NotificationsPage;
